<template>
  <div>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-tabs class="ma-2" v-model="activeTab" color="primary" dark>
      <v-tab>General</v-tab>
      <v-tab>Data</v-tab>
      <v-tab>Assets</v-tab>
      <v-tab>Triggers</v-tab>
      <v-tab>Lookups</v-tab>
      <v-tab>Api Keys</v-tab>
      <v-tab-item>
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="profile.name"
                  :counter="100"
                  label="Name"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="profile.description" :counter="200" label="Description"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="organizations"
                  item-text="name"
                  item-value="id"
                  v-model="profile.organizationId"
                  :counter="100"
                  label="Store identities to organization"
                  clearable
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="profile.retentionDays"
                  type="number"
                  required
                  label="Bewaartermijn (dagen)"
                  :rules="[v => (v !== 0 && !!v) || 'this field is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select :items="colors" v-model="profile.color" label="Color">
                  <template v-slot:selection="{item}">
                    <v-list-item-avatar>
                      <v-icon :color="item">brightness_1</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>{{item}}</v-list-item-content>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list-item-avatar>
                      <v-icon :color="item">brightness_1</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>{{item}}</v-list-item-content>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete :items="icons" v-model="profile.icon" label="Icon">
                  <template v-slot:selection="{item}">
                    <v-list-item-avatar>
                      <v-icon>{{item}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>{{item}}</v-list-item-content>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list-item-avatar>
                      <v-icon>{{item}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>{{item}}</v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-switch
                  v-model="profile.enableGroups"
                  label="Enable groups"
                ></v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select :items="sortTypes" 
                v-model="profile.sortType" 
                label="Sort type">
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-tab-item>
      <v-tab-item @click="setSortableFields()">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-list>
                  <v-list-group
                    v-for="(step, stepIndex) in profile.steps"
                    :key="step.id"
                    style="border-bottom: 1px solid #ccc;"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>{{ getStepName(stepIndex) }}</v-list-item-title>
                      <v-btn class="ma-2" @click="deleteStep(stepIndex)" icon ripple>
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="step.name"
                                label="Name"
                                :counter="100"
                                :rules="nameRules"
                                required
                                @blur="updateStepName(stepIndex, step.name)"
                              ></v-text-field>
                              <v-text-field
                                v-model="step.description"
                                :counter="200"
                                label="Description"
                              ></v-text-field>
                               <v-switch
                                v-model="step.isValidationStep"
                                label="Validate Step"
                              ></v-switch>
                              <v-card style="margin-top:10px">
                                <v-system-bar>
                                  <span>Fields</span>
                                </v-system-bar>
                                <v-list :class="'fieldList'+stepIndex">
                                  <v-list-group
                                    prepend-icon="drag_handle"
                                    v-for="(field, fieldIndex) in orderedStepFields(step.id)"
                                    :key="field.id"
                                    style="border-bottom: 1px solid #ccc;"
                                  >
                                    <template v-slot:activator>
                                      <v-list-item-title>{{ getFieldName(stepIndex, fieldIndex) }}</v-list-item-title>
                                      <v-btn
                                        class="ma-2"
                                        @click="deleteField(stepIndex, fieldIndex)"
                                        icon
                                        ripple
                                      >
                                        <v-icon color="error">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-container fluid>
                                          <v-row>
                                            <v-col cols="12">
                                              <v-autocomplete
                                                v-if="field.type == 37"
                                                :items="organizationProfiles"
                                                item-text="name"
                                                item-value="id"
                                                v-model="field.name"
                                                label="Profile"
                                                @blur="updateFieldName(stepIndex, fieldIndex, getOrganizationProfileName(field.name))"
                                              ></v-autocomplete>
                                              <v-autocomplete
                                                v-if="field.type == 38"
                                                :items="documentTypes"
                                                item-text="name"
                                                item-value="id"
                                                v-model="field.name"
                                                label="Type"
                                                @blur="updateFieldName(stepIndex, fieldIndex, getDocumentTypeName(field.name))"
                                              ></v-autocomplete>
                                              <v-text-field
                                                v-if="field.type != 37 && field.type != 38"
                                                v-model="field.name"
                                                label="Name"
                                                :counter="100"
                                                :rules="nameRules"
                                                required
                                                @blur="updateFieldName(stepIndex, fieldIndex, field.name)"
                                              ></v-text-field>
                                              <v-text-field
                                                v-model="field.description"
                                                :counter="200"
                                                label="Description"
                                              ></v-text-field>
                                              <v-text-field
                                                v-model="field.value"
                                                :counter="200"
                                                label="Default value"
                                              ></v-text-field>
                                              <v-text-field
                                                v-model="field.settings"
                                                :counter="200"
                                                label="Settings"
                                              ></v-text-field>
                                              <v-autocomplete
                                                v-if="fieldTypes.length > 0"
                                                :items="fieldTypes"
                                                item-text="name"
                                                item-value="id"
                                                v-model="field.type"
                                                label="Field type"
                                                :rules="[v => fieldTypes.some(i => i.id == v) || 'this field is required']"
                                                required
                                              ></v-autocomplete>
                                              <v-card v-if="field.type == 5">
                                                <v-system-bar>
                                                  <span>Items</span>
                                                </v-system-bar>
                                                <v-list>
                                                  <v-list-group
                                                    v-for="(fieldItem, fieldItemIndex) in field.items"
                                                    :key="fieldItem.id"
                                                  >
                                                    <template v-slot:activator>
                                                      <v-list-item-title>{{ getFieldItemName(stepIndex, fieldIndex, fieldItemIndex) }}</v-list-item-title>
                                                      <v-btn
                                                        class="ma-2"
                                                        @click="deleteFieldItem(stepIndex, fieldIndex, fieldItemIndex)"
                                                        icon
                                                        ripple
                                                      >
                                                        <v-icon color="error">delete</v-icon>
                                                      </v-btn>
                                                    </template>
                                                    <v-list-item>
                                                      <v-list-item-content>
                                                        <v-container fluid>
                                                          <v-row>
                                                            <v-col cols="12">
                                                              <v-text-field
                                                                v-model="fieldItem.name"
                                                                label="Name"
                                                                :counter="100"
                                                                :rules="nameRules"
                                                                required
                                                                @blur="updateFieldItemName(stepIndex, fieldIndex, fieldItemIndex, fieldItem.name)"
                                                              ></v-text-field>
                                                              <v-text-field
                                                                v-model="fieldItem.value"
                                                                label="Value"
                                                                :counter="100"
                                                                :rules="nameRules"
                                                                required
                                                              ></v-text-field>
                                                            </v-col>
                                                          </v-row>
                                                        </v-container>
                                                      </v-list-item-content>
                                                    </v-list-item>
                                                  </v-list-group>
                                                </v-list>
                                                <v-card-actions>
                                                  <div class="flex-grow-1"></div>
                                                  <v-btn
                                                    @click="addFieldItem(stepIndex, fieldIndex)"
                                                    color="success"
                                                    small
                                                  >
                                                    add item
                                                    <v-icon right dark>add</v-icon>
                                                  </v-btn>
                                                </v-card-actions>
                                              </v-card>
                                              <v-row>
                                                <v-col cols="12" sm="6" md="3">
                                                  <v-switch
                                                    :label="`Required`"
                                                    v-model="field.isRequired"
                                                  ></v-switch>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                  <v-switch
                                                    :label="`GroupField`"
                                                    v-model="field.isGroupField"
                                                  ></v-switch>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                  <v-switch
                                                    :label="`Show on listview`"
                                                    v-model="field.showOnList"
                                                  ></v-switch>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                  <v-switch
                                                    :label="`Filter on listview`"
                                                    v-model="field.filterOnList"
                                                    :disabled="field.type != 5"
                                                  ></v-switch>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-group>
                                </v-list>
                                <v-card-actions>
                                  <div class="flex-grow-1"></div>
                                  <v-btn
                                    class="ma-2"
                                    @click="addField(stepIndex)"
                                    color="success"
                                    small
                                    dark
                                  >
                                    add field
                                    <v-icon right dark>add</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
                <v-btn class="ma-2" @click="addStep" color="success" small dark>
                  add set
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-list>
                  <v-list-group
                    v-for="(identityProfileAssetProfile, assetProfileIndex) in profile.identityProfileAssetProfiles"
                    :key="assetProfileIndex"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>{{ getAssetProfileName(identityProfileAssetProfile.assetProfileId) }}</v-list-item-title>
                      <v-btn
                        class="ma-2"
                        @click="profile.identityProfileAssetProfiles.splice(assetProfileIndex, 1)"
                        icon
                        ripple
                      >
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-if="assetProfiles.length > 0"
                                :items="assetProfiles"
                                item-text="name"
                                item-value="id"
                                v-model="identityProfileAssetProfile.assetProfileId"
                                label="Asset type"
                                :rules="[v => !!v || 'this field is required']"
                                required
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
                <v-btn class="ma-2" @click="addAssetProfile()" color="success" small dark>
                  add assetProfile
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-tab-item>
      <v-tab-item @click="setSortableActions()">
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-list>
                  <v-list-group
                    v-for="(trigger, triggerIndex) in orderedTriggers"
                    :key="triggerIndex"
                  >
                    <template v-slot:activator>
                      <v-list-item-title>{{ getTriggerName(triggerIndex) }}</v-list-item-title>
                      <v-btn class="ma-2" @click="deleteTrigger(triggerIndex)" icon ripple>
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-if="triggerSources.length > 0"
                                :items="triggerSources"
                                item-text="name"
                                item-value="id"
                                v-model="trigger.source"
                                label="Source"
                                :rules="[v => triggerSources.some(i => i.id == v) || 'this field is required']"
                                required
                                @blur="getTriggerNameArrays()"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="trigger.criteria"
                                :counter="200"
                                label="Criteria"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-card>
                                <v-system-bar>
                                  <span>Actions</span>
                                </v-system-bar>
                                <v-list :class="'actionList'+triggerIndex">
                                  <v-list-group
                                    prepend-icon="drag_handle"
                                    v-for="(action, actionIndex) in orderedTriggerActions(trigger.id)"
                                    :key="action.id"
                                    style="border-bottom: 1px solid #ccc;"
                                  >
                                    <template v-slot:activator>
                                      <v-list-item-title>{{ getTriggerActionName(triggerIndex, actionIndex) }}</v-list-item-title>
                                      <v-btn
                                        class="ma-2"
                                        @click="deleteAction(triggerIndex, actionIndex)"
                                        icon
                                        ripple
                                      >
                                        <v-icon color="error">delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list-item>
                                      <v-list-item-content>
                                        <v-container fluid>
                                          <v-row>
                                            <v-col cols="12">
                                              <v-autocomplete
                                                v-if="triggerActionTypes && triggerActionTypes.length > 0"
                                                :items="triggerActionTypes"
                                                item-text="name"
                                                item-value="id"
                                                v-model="action.type"
                                                label="Action type"
                                                :rules="[v => triggerActionTypes.some(i => i.id == v) || 'this field is required']"
                                                required
                                                @blur="getTriggerNameArrays()"
                                              ></v-autocomplete>
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12" v-if="action.type != 1">
                                              <v-text-field
                                                v-model="action.plugin"
                                                :counter="100"
                                                label="Plugin"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12" v-if="action.type != 1">
                                              <v-textarea auto-grow
                                                v-model="action.parameter"
                                                label="Parameters"
                                              ></v-textarea>
                                              </v-col>
                                              <v-col cols="12" v-else>
                                              <v-text-field v-model="action.parameter.recipient" :counter="200" label="Recipient(s)" />
                                              <v-text-field v-model="action.parameter.subject" :counter="200" label="Subject" />
                                              <v-btn class="float-right" style="z-index:1" @click="modalEdit = !modalEdit">&lt; &gt;</v-btn>
                                              <tiptap-vuetify 
                                                v-model="action.parameter.body" 
                                                :native-extensions="editorNativeExtensions"
                                                :extensions="editorExtensions" />
                                              <v-textarea class="mt-4" v-if="modalEdit == true" auto-grow
                                                v-model="action.parameter.body"
                                                label="Parameters body"
                                              ></v-textarea>
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="6">
                                              <v-text-field
                                                v-model="action.retryCount"
                                                :counter="10"
                                                label="Retry Count"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                              <v-text-field
                                                v-model="action.retryDelayMinutes"
                                                :counter="10"
                                                label="Retry Delay Minutes"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list-group>
                                </v-list>
                                <v-card-actions>
                                  <div class="flex-grow-1"></div>
                                  <v-btn
                                    class="ma-2"
                                    @click="addTriggerAction(triggerIndex)"
                                    color="success"
                                    small
                                    dark
                                  >
                                    add action
                                    <v-icon right dark>add</v-icon>
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
                <v-btn class="ma-2" @click="addTrigger()" color="success" small dark>
                  add trigger
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-list>
                  <v-list-group v-for="(lookup, lookupIndex) in profile.lookups" :key="lookupIndex">
                    <template v-slot:activator>
                      <v-list-item-title>{{ getLookupName(lookupIndex) }}</v-list-item-title>
                      <v-btn
                        class="ma-2"
                        @click="profile.lookups.splice(lookupIndex, 1)"
                        icon
                        ripple
                      >
                        <v-icon color="error">delete</v-icon>
                      </v-btn>
                    </template>
                    <v-list-item>
                      <v-list-item-content>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="lookup.name"
                                :counter="100"
                                label="Name"
                                :rules="nameRules"
                                required
                                @blur="updateLookupName(lookupIndex, lookup.name)"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="lookup.description"
                                :counter="100"
                                label="Description"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="lookup.plugin" :counter="100" label="Plugin"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="lookup.address" :counter="500" label="Address"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="lookup.parameters"
                                :counter="500"
                                label="Parameters"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="lookup.schedule" :counter="1" label="Schedule"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
                <v-btn class="ma-2" @click="addLookup()" color="success" small dark>
                  add lookup
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-container fluid>
          <v-row style="background:#e0e0e0;">
            <v-col cols="12">
              <v-card style="margin-top:10px">
                <v-system-bar>
                  <span>API Keys</span>
                </v-system-bar>
                <v-list>
                  <v-list-group
                    v-for="(apiKey, index) in profile.apiKeys"
                    :key="index"
                    style="border-bottom: 1px solid #ccc;"
                  >
                    <template v-slot:activator>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ getApiKeyName(apiKey.id) }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-btn class="ma-2" @click="deleteApiKey(index)" icon ripple>
                            <v-icon color="error">delete</v-icon>
                          </v-btn>
                        </v-list-item-icon>
                      </v-list-item>
                    </template>
                    <v-container fluid style="padding: 0 30px;">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="apiKey.description"
                            label="Description"
                            :counter="100"
                            :rules="nameRules"
                            required
                            @blur="updateApiKeyDescription(apiKey.id, apiKey.description)"
                          ></v-text-field>
                          <v-text-field
                            v-model="apiKey.startDate"
                            :counter="48"
                            label="Start date"
                          ></v-text-field>
                          <v-text-field v-model="apiKey.endDate" :counter="48" label="End date"></v-text-field>
                          <v-text-field
                            v-model="apiKey.key"
                            label="Key"
                            readonly
                            placeholder="auto generated"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-list-group>
                </v-list>
              </v-card>
              <v-btn class="ma-2" @click="addApiKey()" color="success" small dark>
                add API Key
                <v-icon right dark>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-col class="ml-5 text-right" cols="12" style="text-align:left !important;padding:0;">
        <v-btn class="ma-2" color="success" style="height:32px;" @click="submit">save</v-btn>
        <v-btn class="ma-2" color="primary" style="height:32px;" @click="back">cancel</v-btn>
        {{submitStatus}}
      </v-col>
    </v-tabs>
  </v-form>
    </div>
</template>

<script>
import Sortable from "sortablejs";
import _ from "lodash";
import colors from '../plugins/colors';
import icons from '../plugins/icons';
import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, Blockquote, HorizontalRule, History } from 'tiptap-vuetify'
import { Table, TableHeader, TableCell, TableRow } from 'tiptap-extensions'
export default {
  components: {
    TiptapVuetify
  },
  props: ["profile"],
  data: () => ({
    editorContent: `
      <p></p>
    `,
    editorExtensions: [
      History,
      Blockquote,
      Link,
      Underline,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [Heading, {
        options: {
          levels: [1, 2, 3, 4]
        }
      }],
      Bold,
      HorizontalRule,
    ],    
    editorNativeExtensions: [
        new Table({ resizable: true,} ),
        new TableHeader(),
        new TableCell(),
        new	TableRow()
    ],
    valid: false,
    activeTab: null,
    showStepIndex: -1,
    showFieldIndex: -1,
    showFieldItemIndex: -1,
    showAssetProfileIndex: -1,
    showTriggerIndex: -1,
    showLookupIndex: -1,
    showActionIndex: -1,
    showApiKeyIndex: -1,
    submitStatus: null,
    fieldTypes: [],
    triggerSources: [],
    actionTypes: [],
    assetProfiles: [],
    organizations: [],
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ],
    colors: colors,
    icons: icons,
    organizationProfiles: [],
    documentTypes: [],
    stepNames: [],
    fieldNames: [],
    fieldItemNames: [],
    triggerNames: [],
    lookupNames: [],
    triggerActionNames: [],
    triggerActionTypes: [],
    selectedFieldList: null,
    sortTypes: [{text:"StartDate",value:0},{text:"EndDate",value:1},{text:"CreatedDate",value:2},{text:"ModifiedDate",value:3}],
    modalEdit: false
  }),
  computed: {
    orderedTriggers() {
      if (!this.profile.triggers) return [];
      return _.orderBy(this.profile.triggers, "order");
    }
  },
  methods: {
    orderedStepFields(stepid) {
      return _.orderBy(
        this.profile.steps.find(s => s.id == stepid).fields,
        "order"
      );
    },
    orderedTriggerActions(triggerid) {
      return _.orderBy(
        this.profile.triggers.find(t => t.id == triggerid).actions,
        "order"
      );
    },
    getOrganizationProfileName(id) {
      var profile = this.organizationProfiles.find(x => x.id == id);
      if (!profile) return "";
      return this.organizationProfiles.find(x => x.id == id).name;
    },
    getDocumentTypeName(id) {
      var type = this.documentTypes.find(x => x.id === id);
      if (!type) return "";
      return this.documentTypes.find(x => x.id == id).name;
    },
    getAssetProfileName(id) {
      var profile = this.assetProfiles.find(x => x.id == id);
      if (!profile) return "";
      return this.assetProfiles.find(x => x.id == id).name;
    },
    getTriggerActionName(triggerIndex, actionIndex) {
      var myName = this.triggerActionNames.find(
        x => x.ti == triggerIndex && x.ai == actionIndex
      );
      return myName ? myName.name : "";
    },
    getFieldName(stepIndex, fieldIndex) {
      return this.fieldNames.find(x => x.si == stepIndex && x.fi == fieldIndex).name;
    },
    getFieldItemName(stepIndex, fieldIndex, fieldItemIndex) {
      return this.fieldItemNames.find(
        x => x.si == stepIndex && x.fi == fieldIndex && x.fii == fieldItemIndex).name;
    },
    getStepName(stepIndex) {
      return this.stepNames.find(x => x.si == stepIndex).name;
    },
    getTriggerName(triggerIndex) {
      var myName = this.triggerNames.find(x => x.ti == triggerIndex);
      return myName ? myName.name : "";
    },
    getLookupName(lookupIndex) {
      var myName = this.lookupNames.find(x => x.li == lookupIndex);
      return myName ? myName.name : "";
    },
    updateLookupName(lookupIndex, lookupName) {
      this.lookupNames.find(x => x.li == lookupIndex).name = lookupName;
    },
    updateFieldName(stepIndex, fieldIndex, fieldName) {
      this.fieldNames.find(
        x => x.si == stepIndex && x.fi == fieldIndex).name = fieldName;
    },
    updateFieldItemName(stepIndex, fieldIndex, fieldItemIndex, fieldItemName) {
      this.fieldItemNames.find(
        x => x.si == stepIndex && x.fi == fieldIndex && x.fii == fieldItemIndex).name = fieldItemName;
    },
    updateStepName(stepIndex, stepName) {
      this.stepNames.find(x => x.si == stepIndex).name = stepName;
    },
    deleteTrigger(triggerIndex) {
      this.profile.triggers.splice(triggerIndex, 1);
      var deleteActions = this.actionNames.filter(x => x.ti == triggerIndex);
      if (deleteActions && deleteActions.length > 0) {
        deleteActions.forEach(x => {
          this.deleteAction(triggerIndex, x.id);
        });
      }
      this.getTriggerNameArrays();
    },
    deleteAction(triggerIndex, actionIndex) {
      this.profile.triggers[triggerIndex].actions.splice(actionIndex, 1);
      this.getTriggerNameArrays();
    },
    deleteStep(stepIndex) {
      this.profile.steps.splice(stepIndex, 1);
      var deleteFields = this.fieldNames.filter(x => x.si == stepIndex);
      if (deleteFields && deleteFields.length > 0) {
        deleteFields.forEach(x => {
          this.deleteField(stepIndex, x.id);
        });
      }
      this.getStepNameArrays();
    },
    deleteField(stepIndex, fieldIndex) {
      this.profile.steps[stepIndex].fields.splice(fieldIndex, 1);
      var deleteFieldItems = this.fieldItemNames.filter(
        x => x.si == stepIndex && x.fi == fieldIndex
      );
      if (deleteFieldItems && deleteFieldItems.length > 0) {
        deleteFieldItems.forEach(x => {
          this.deleteFieldItem(stepIndex, fieldIndex, x.id);
        });
      }
      this.getStepNameArrays();
    },
    deleteFieldItem(stepIndex, fieldIndex, fieldItemIndex) {
      this.profile.steps[stepIndex].fields[fieldIndex].items.splice(
        fieldItemIndex,
        1
      );
      this.getStepNameArrays();
    },
    addAssetProfile() {
      if (!this.profile.identityProfileAssetProfiles) {
        this.profile.identityProfileAssetProfiles = [];
      }
      this.profile.identityProfileAssetProfiles.push({
        identityProfileId: this.profile.id,
        assetProfileId: null
      });
      this.showAssetProfileIndex =
        this.profile.identityProfileAssetProfiles.length - 1;
    },
    addTrigger() {
      if (!this.profile.triggers) {
        this.profile.triggers = [];
      }
      this.profile.triggers.push({ source: 0, actions: [] });
      this.showTriggerIndex = this.profile.triggers.length - 1;
      this.getTriggerNameArrays();
    },
    addLookup() {
      if (!this.profile.lookups) {
        this.profile.lookups = [];
      }
      this.profile.lookups.push({ schedule: 0 });
      this.showLookupIndex = this.profile.lookups.length - 1;
      this.getLookupNameArrays();
    },
    addStep() {
      this.profile.steps.push({ name: "", fields: [] });
      this.showStepIndex = this.profile.steps.length - 1;
      this.showFieldIndex = -1;
      this.getStepNameArrays();
    },
    addTriggerAction(triggerIndex) {
      this.profile.triggers[triggerIndex].actions.push({ type: 0 });
      this.showActionIndex =
        this.profile.triggers[triggerIndex].actions.length - 1;
      this.getTriggerNameArrays();
    },
    addField(stepIndex) {
      this.profile.steps[stepIndex].fields.push({
        name: "",
        type: 0,
        items: []
      });
      this.showFieldIndex = this.profile.steps[stepIndex].fields.length - 1;
      this.getStepNameArrays();
    },
    addFieldItem(stepIndex, fieldIndex) {
      this.profile.steps[stepIndex].fields[fieldIndex].items.push({ name: "" });
      this.showFieldItemIndex =
        this.profile.steps[stepIndex].fields[fieldIndex].items.length - 1;
      this.getStepNameArrays();
    },
    addApiKey() {
      this.profile.apiKeys.push({ description: "", key: "" });
      this.showApiKeyIndex = this.profile.apiKeys.length - 1;
    },
    getApiKeyName(apiKeyIndex) {
      return this.profile.apiKeys.find(x => x.id == apiKeyIndex).description;
    },
    updateApiKeyDescription(apiKeyIndex, apiKeyDescription) {
      this.profile.apiKeys.find(
        x => x.id == apiKeyIndex
      ).description = apiKeyDescription;
    },
    deleteApiKey(apiKeyIndex) {
      this.profile.apiKeys.splice(apiKeyIndex, 1);
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
      } else {
        let profile = this.profile;
        if (profile.triggers) {
          profile.triggers.forEach(t => {
            if (t.actions) {
              t.actions.forEach(a => {
                if (a.type == 1 && a.parameter && a.parameter.body) {
                  a.parameter = JSON.stringify(a.parameter);
                }
              });
            }
          });
        }
        if(profile.identityProfileAssetProfiles) {
          profile.assetProfiles = [];
          profile.identityProfileAssetProfiles.forEach(p => {
            profile.assetProfiles.push(this.assetProfiles.find(a => a.id == p.assetProfileId));
          });
        }
        if (this.profile.id == undefined) {
          this.submitStatus = "POSTING";
          this.$http
            .post("api/identityprofiles/", profile)
            .then(request => {
              if (request.status == 201) {
                this.submitStatus = "OK";
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "3100", e);
              this.submitStatus = "ERROR";
            });
        } else {
          this.submitStatus = "PUTTING";
          this.$http
            .put("api/identityprofiles/" + profile.id, profile)
            .then(request => {
              if (request.status == 201) {
                this.submitStatus = "OK";
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "3101", e);
              this.submitStatus = "ERROR";
            });
        }
      }
    },
    back() {
      this.$refs.form.reset();
      this.$emit("reset");
    },
    getAssetProfileTypes() {
      this.$http
        .get("api/assetprofiles")
        .then(request => {
          if (request.data) {
            this.assetProfiles = request.data;
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3102", e);
        });
    },
    getFieldTypes() {
      this.$http
        .get("api/identityprofiles/fieldtypes")
        .then(request => {
          this.fieldTypes = request.data;
          this.getStepNameArrays();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3103", e);
        });
    },
    getTriggerSources() {
      this.$http
        .get("api/identityprofiles/triggersources")
        .then(request => {
          this.triggerSources = request.data;
          this.getTriggerActionTypes();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3104", e);
        });
    },
    getTriggerActionTypes() {
      this.$http
        .get("api/identityprofiles/triggeractiontypes")
        .then(request => {
          this.triggerActionTypes = request.data;
          this.getTriggerNameArrays();
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3105", e);
        });
    },
    getOrganizationProfiles() {
      this.$http
        .get("api/organizationprofiles/")
        .then(request => {
          if (request.status == 200) {
            this.organizationProfiles = request.data;
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3106", e);
        });
    },
    getOrganizations() {
      this.$http
        .get("api/organizations/")
        .then(request => {
          if (request.status == 200) {
            this.organizations = request.data;
            this.getStepNameArrays();
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3107", e);
        });
    },
    getDocumentTypes() {
      this.$http
        .get("api/documenttypes/")
        .then(request => {
          if (request.status == 200) {
            this.documentTypes = request.data;
            this.getStepNameArrays();
          }
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "3108", e);
        });
    },
    setSortableFields() {
      this.profile.steps.forEach((s, si) => {
        let selectedFieldList = document.querySelector(
          "div.v-list.v-sheet.v-sheet--tile.theme--light.fieldList" + si
        );
        if (selectedFieldList != null) {
          const _self = this;
          Sortable.create(selectedFieldList, {
            group: si,
            onEnd({ newIndex, oldIndex }) {
              let selectedFields = _self.profile.steps[si].fields;
              var selectedField = selectedFields.splice(oldIndex, 1)[0];
              selectedFields.splice(newIndex, 0, selectedField);
              _self.getStepNameArrays();
            }
          });
        }
      });
    },
    setSortableActions() {
      this.profile.triggers.forEach((t, ti) => {
        let selectedAcionList = document.querySelector(
          "div.v-list.v-sheet.v-sheet--tile.theme--light.actionList" + ti
        );
        if (selectedAcionList != null) {
          const _self = this;
          Sortable.create(selectedAcionList, {
            group: ti,
            onEnd({ newIndex, oldIndex }) {
              let selectedActions = _self.profile.triggers[ti].actions;
              var selectedAction = selectedActions.splice(oldIndex, 1)[0];
              selectedActions.splice(newIndex, 0, selectedAction);
              _self.getStepNameArrays();
            }
          });
        }
      });
    },
    getStepNameArrays() {
      this.stepNames = [];
      this.fieldNames = [];
      this.fieldItemNames = [];
      if (this.profile && this.profile.steps) {
        this.showStepIndex = this.profile.steps.length - 1;
        this.profile.steps.forEach((s, si) => {
          this.stepNames.push({ si: si, name: s.name });
          s.fields.forEach((f, fi) => {
            f.order = fi;
            if (f.type == 37) {
              this.fieldNames.push({
                si: si,
                fi: fi,
                name: this.getOrganizationProfileName(f.name)
              });
            } else if (f.type == 38) {
              this.fieldNames.push({
                si: si,
                fi: fi,
                name: this.getDocumentTypeName(f.name)
              });
            } else {
              this.fieldNames.push({ si: si, fi: fi, name: f.name });
            }
            f.items.forEach((i, ii) => {
              this.fieldItemNames.push({
                si: si,
                fi: fi,
                fii: ii,
                name: i.name
              });
            });
          });
        });
      }
    },
    getTriggerNameArrays() {
      this.triggerNames = [];
      this.triggerActionNames = [];
      if (this.profile && this.profile.triggers) {
        this.showTriggerIndex = this.profile.triggers.length - 1;
        this.profile.triggers.forEach((t, ti) => {
          this.triggerNames.push({
            ti: ti,
            name: this.triggerSources.find(ts => ts.id == t.source).name
          });
          t.actions.forEach((a, ai) => {
            if (a.type == 1) {
              if (a.parameter) {
                a.parameter = JSON.parse(a.parameter)
              } else {
                a.parameter = { recipient: '', subject: '', body: '' }
              }
            }
            a.order = ai;
            this.triggerActionNames.push({
              ti: ti,
              ai: ai,
              name: this.triggerActionTypes.find(tat => tat.id == a.type).name
            });
          });
        });
      }
    },
    getLookupNameArrays() {
      this.lookupNames = [];
      if (this.profile && this.profile.lookups) {
        this.showLookupIndex = this.profile.lookups.length - 1;
        this.profile.lookups.forEach((l, li) => {
          this.lookupNames.push({ li: li, name: l.name });
        });
      }
    }
  },
  mounted: function() {
    this.getAssetProfileTypes();
    this.getFieldTypes();
    this.getTriggerSources();
    this.getOrganizationProfiles();
    this.getOrganizations();
    this.getDocumentTypes();
    this.getLookupNameArrays();
    if (this.profile && this.profile.identityProfileAssetProfiles) {
      this.showAssetProfileIndex =
        this.profile.identityProfileAssetProfiles.length - 1;
    }
  }
};
</script>